export const CODE_LENGTH = 6;

export const initialInputs = new Array(CODE_LENGTH).fill(0).map((_v, index) => ({ index, value: "" }));

export const isValidCode = (str) => /^\d{6}$/.test(str);

export const inputIndexIsInBounds = (index) => index < CODE_LENGTH && index >= 0;

export const getInputIndex = (e) => Number(e.target.getAttribute("data-index"));

export const getDigits = (value = "") => value.replace(/\D/g, "");



// WEBPACK FOOTER //
// ./src/shared/components/CodeInput/helpers.js